import type { BrokerListQuery } from '@/schemas/broker'

/**
 * Every broker that traded, for PV range's two side filters (Buyer/Seller) —
 * and, now, for `PVRangeScreen.loader.ts` to prefetch alongside the profile.
 *
 * One page of 100 covers the ~52 houses NEPSE lists, and turnover order puts
 * the names a member is most likely to want at the top of each menu.
 * `period` is pinned to `'today'` because this call exists only to populate
 * two menus, not to show a number — it is deliberately NOT tied to this
 * screen's own period chip, which would refetch the whole broker list every
 * time the profile's window changed.
 *
 * Moved out of `PVRangeScreen.tsx` (a component file) into its own `lib`
 * module: route loaders are not code-split, so anything they import ships in
 * the entry chunk, and a loader may not import a component module at all —
 * see docs/route-loading.md, "Steps" step 2.
 */
export const PV_RANGE_BROKER_LIST_QUERY: BrokerListQuery = {
  page: 1,
  pageSize: 100,
  period: 'today',
  sort: 'turnover',
}
